// removed by extract-text-webpack-plugin
module.exports = {"Select-animation-fadeIn":"_2ZeXISyjfWdSOIHTyxvCke","Select-animation-spin":"_3Ryft7_q_hfXTbKd2atMxH"};


//////////////////
// WEBPACK FOOTER
// ./src/client/styles/react-select.css
// module id = 429
// module chunks = 58